import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveBillingAddress, GetBillingAddress } from './index';

// Api's
import { addressApi } from '../../api';
import { AddressByBodyshopResponse } from '@/main/models/response';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getBillingAddressSaga(action: GetBillingAddress) {
  try {
    const response: AxiosResponse<Result<AddressByBodyshopResponse[]>> = yield call(
      addressApi.getBillingAddressSummary,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveBillingAddress(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveBillingAddress(null, true, resultError.messagesDataError));
    }
  }
}
